export {
  RangeSlider,
  type RangeSliderProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/RangeSlider';
